import { useEffect, useState } from 'react'
import { onSyncStart, onSyncComplete } from '@/lib/syncManager'

type Phase = 'idle' | 'syncing' | 'done' | 'error'

export default function CacheStatusBar() {
  const [phase, setPhase] = useState<Phase>('idle')
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  useEffect(() => {
    const unsubStart = onSyncStart(() => setPhase('syncing'))
    const unsubComplete = onSyncComplete(({ success, error }) => {
      if (success) {
        setPhase('done')
        setTimeout(() => setPhase('idle'), 3000)
      } else {
        const msg = error instanceof Error ? error.message : 'Unknown error'
        setErrorMessage(msg)
        setPhase('error')
        setTimeout(() => setPhase('idle'), 6000)
      }
    })
    return () => { unsubStart(); unsubComplete() }
  }, [])

  if (phase === 'idle') return null

  if (phase === 'syncing') {
    return (
      <div className="absolute inset-x-0 top-0 z-50 border-b border-blue-800 bg-blue-950 px-3 py-1 text-[11px] font-medium flex items-center justify-center gap-2" style={{ minHeight: '24px' }}>
        <svg className="animate-spin h-3 w-3" style={{ color: '#93c5fd' }} viewBox="0 0 24 24" fill="none">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
        </svg>
        <span style={{ color: '#93c5fd' }}>Syncing data for offline use...</span>
      </div>
    )
  }

  if (phase === 'error') {
    return (
      <div className="absolute inset-x-0 top-0 z-50 border-b border-red-800 bg-red-950 px-3 py-1 text-[11px] font-medium flex items-center justify-center gap-2" style={{ minHeight: '24px' }}>
        <span style={{ color: '#fca5a5' }}>Sync failed{errorMessage ? `: ${errorMessage}` : ''}</span>
      </div>
    )
  }

  return (
    <div className="absolute inset-x-0 top-0 z-50 border-b border-green-800 bg-green-950 px-3 py-1 text-[11px] font-medium flex items-center justify-center gap-2" style={{ minHeight: '24px' }}>
      <span style={{ color: '#86efac' }}>Ready for offline</span>
    </div>
  )
}
